import {
  CONNECTOR_BRAND_ICON_BY_SOURCE,
  getConnectorIconClass,
} from "../connectorBrandIcons";

/**
 * Live connector apps shown in the connect-sources empty state.
 *
 * @example
 * CONNECT_SOURCES_LIVE[0].appName // "Granola"
 */
export const CONNECT_SOURCES_LIVE = [
  {
    id: "granola-digest",
    appName: "Granola",
    workflowType: "granola_daily_digest",
    setupPath: "/business/workflows/new/granola-digest",
    Icon: CONNECTOR_BRAND_ICON_BY_SOURCE.granola,
    iconProps: {},
    iconClass: getConnectorIconClass("granola"),
    description: "Action items from your Granola notes.",
  },
  {
    id: "notion-digest",
    appName: "Notion",
    workflowType: "notion_daily_digest",
    setupPath: "/business/workflows/new/notion-digest",
    Icon: CONNECTOR_BRAND_ICON_BY_SOURCE.notion,
    iconProps: {},
    iconClass: getConnectorIconClass("notion"),
    description:
      "Action items from your Notion AI meeting notes.",
  },
  {
    id: "zoom-digest",
    appName: "Zoom",
    workflowType: "zoom_daily_digest",
    setupPath: "/business/workflows/new/zoom-digest",
    Icon: CONNECTOR_BRAND_ICON_BY_SOURCE.zoom,
    iconProps: {},
    iconClass: getConnectorIconClass("zoom"),
    description: "Action items from your Zoom recordings.",
  },
  {
    id: "gong-digest",
    appName: "Gong",
    workflowType: "gong_daily_digest",
    setupPath: "/business/workflows/new/gong-digest",
    Icon: CONNECTOR_BRAND_ICON_BY_SOURCE.gong,
    iconProps: {},
    iconClass: getConnectorIconClass("gong"),
    description: "Action items from your Gong calls.",
  },
  {
    id: "google-meet-digest",
    appName: "Google Meet",
    workflowType: "google_meet_daily_digest",
    setupPath: "/business/workflows/new/google-meet-digest",
    Icon: CONNECTOR_BRAND_ICON_BY_SOURCE.google_meet,
    iconProps: {},
    iconClass: getConnectorIconClass("google_meet"),
    description: "Action items from your Meet transcripts.",
  },
  {
    id: "email-digest",
    appName: "Gmail",
    workflowType: "email_daily_digest",
    setupPath: "/business/workflows/new/email-digest",
    Icon: CONNECTOR_BRAND_ICON_BY_SOURCE.gmail,
    iconProps: {},
    iconClass: getConnectorIconClass("gmail"),
    description: "Action items from meeting emails only.",
  },
];

/** Onboarding order: meeting sources first, Gmail last (5th). */
const ONBOARDING_LIVE_SOURCE_IDS = [
  "granola-digest",
  "zoom-digest",
  "gong-digest",
  "google-meet-digest",
  "email-digest",
];

/** Live connectors on full-screen onboarding (excludes calendar). */
export const CONNECT_SOURCES_ONBOARDING_LIVE = ONBOARDING_LIVE_SOURCE_IDS.map((id) =>
  CONNECT_SOURCES_LIVE.find((source) => source.id === id)
).filter(Boolean);

const comingSoonSource = (id, appName, sourceType) => ({
  id,
  appName,
  Icon: CONNECTOR_BRAND_ICON_BY_SOURCE[sourceType],
  iconProps: {},
  iconClass: getConnectorIconClass(sourceType),
});

/**
 * Connector apps not yet available — shown as muted list rows.
 *
 * @example
 * CONNECT_SOURCES_COMING_SOON.map((app) => app.appName) // ["Slack", ...]
 */
export const CONNECT_SOURCES_COMING_SOON = [
  comingSoonSource("otter", "Otter", "otter"),
  comingSoonSource("fireflies", "Fireflies", "fireflies"),
  comingSoonSource("fathom", "Fathom", "fathom"),
  comingSoonSource("tldv", "tl;dv", "tldv"),
  comingSoonSource("avoma", "Avoma", "avoma"),
  comingSoonSource("readai", "Read.ai", "readai"),
  comingSoonSource("grain", "Grain", "grain"),
  comingSoonSource("circleback", "Circleback", "circleback"),
  comingSoonSource("fellow", "Fellow", "fellow"),
  comingSoonSource("teams", "Microsoft Teams", "teams"),
];

/**
 * Live write-back CRM connectors (not digest sources — connected via OAuth for
 * CRM write-back, then used by the action-item performer). Opens a setup panel
 * at ``setupPath`` (same chrome as Zoom/Granola), then OAuth.
 *
 * Salesforce is deprecated for now (not offered as a new connection anywhere in
 * the app) but its backend OAuth/write-back code stays intact — this catalog is
 * just the UI surface for starting a *new* connection, so removing its entry
 * here is a UI-only change, not a backend teardown.
 *
 * @example
 * CONNECT_SOURCES_CRM[0].setupPath // "/business/workflows/new/attio"
 */
export const CONNECT_SOURCES_CRM = [
  {
    id: "attio",
    appName: "Attio",
    oauthProvider: "attio",
    setupPath: "/business/workflows/new/attio",
    Icon: CONNECTOR_BRAND_ICON_BY_SOURCE.attio,
    iconProps: {},
    iconClass: getConnectorIconClass("attio"),
    description: "Write meeting outcomes back to Attio, only when you confirm.",
  },
];

export const CATALOG_BY_WORKFLOW_TYPE = Object.fromEntries(
  CONNECT_SOURCES_LIVE.map((source) => [source.workflowType, source])
);

export const APP_ID_TO_WORKFLOW_TYPE = Object.fromEntries(
  CONNECT_SOURCES_LIVE.map((source) => [source.id, source.workflowType])
);
